import * as React from "react"
import Header from "../assets/components/header"
import * as css from "../assets/styles/layout.module.scss"

const Layout = (props) => {
	return (
		<>
			<Header pageTitle={props.pageTitle} onMain={props.onMain ? "true" : null}></Header>
		</>
	)
}

export default Layout
